import React, { useState, useEffect } from "react";
import Header from "../HeaderNew/component";
import NearbyStores from "../HomePageNew/near-by-store/index";
import Footer from "../../components/common/Footer";
import { ToastContainer } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import Breadcrumb from "../../components/common/breadcrumb";
import "./styles.scss";

const TopGroceryStores = () => {
    const location = useLocation();
    const recommendedSellers = location?.state?.recommendedSellers || [];
    const categoryParam = location?.state?.categoryParam || "";
    const navigate = useNavigate();
    const [showAllStores, setShowAllStores] = useState(false);
    const sellersToDisplay = showAllStores ? recommendedSellers : recommendedSellers.slice(0, 24);
    const sellerDetails = location?.state?.sellerDetails || "";
    const [isHeaderHide, setIsHeaderHide] = useState(false);

    const handleViewMore = () => {
        setShowAllStores(true);
    };

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setIsHeaderHide(true);
            } else {
                setIsHeaderHide(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            <div className="top-grocery-stores-container-kl">
                <Header hide={isHeaderHide} title={"Top Grocery Stores"} />
                <Breadcrumb category={categoryParam} sellerDetails={sellerDetails} />
                <div className="container">
                    <div className="row">
                        <div className="mobile-secondary-header-kl product-detail-mobile-header">
                            <div className="mobile-secondary-header-inner-kl">
                                <div className="mobile-secondary-header-title-kl">
                                    {"Top Grocery Stores"}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div className="page-header-bg-container-kl">
                                <div className="page-header-bg-container-inner-kl">
                                    <div className="page-header-location-kl">
                                        <div className="page-header-location-title-kl">
                                            {"Top Grocery Stores"}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="top-grocery-stores-inner-container-kl">
                    <NearbyStores
                        sellers={sellersToDisplay}
                        navigate={navigate}
                        categoryParam={categoryParam}
                    />
                    {recommendedSellers.length > 24 && !showAllStores && (
                        <div className="container mt-4">
                            <div className="row">
                                <div className="col-12 text-center">
                                    <div className="view-more-container-kl">
                                        <button
                                            onClick={handleViewMore}
                                            className="view-more-product-btn-kl"
                                        >
                                            View More
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <Footer />
        </>
    );
};

export default TopGroceryStores;
